export interface CorpusManifestClass {
  id: number;
  rhyme: string;
  lines: string;
  count: number;
  bytes: number;
  sha256: string;
}

export interface CorpusManifest {
  format: 1;
  corpusId: string;
  codecVersion: string;
  createdAt: string;
  normalization: string;
  generationNormalizer: {
    library: string;
    version: string;
    configuration: string;
    pipeline: string;
  };
  decodeNormalizer: {
    library: string;
    version: string;
    configuration: string;
    pipeline: string;
    dictionarySource: string;
    phraseDictionarySha256: string;
    characterDictionarySha256: string;
    canonicalExceptionsSha256: string;
    integrity: string;
  };
  lineBits: number;
  rhymeBits: number;
  withinClassBits: number;
  totalLines: number;
  classes: CorpusManifestClass[];
}

export class AmbiguousCorpusLineError extends Error {
  constructor() {
    super("The normalized sentence maps to more than one corpus entry.");
    this.name = "AmbiguousCorpusLineError";
  }
}

export interface InstallProgress {
  phase: "download" | "index" | "ready";
  complete: number;
  total: number;
}

export interface Corpus {
  readonly id: string;
  readonly manifest: CorpusManifest;
  ensureReady(onProgress?: (progress: InstallProgress) => void): Promise<void>;
  getLine(index: number): Promise<string>;
  getIndex(line: string): Promise<number | undefined>;
}
